module.exports = __webpack_public_path__ + "img/UTI-Logo.dc837703.png";